var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ListButton",class:{'IsActive': _vm.isActive},on:{"click":_vm.onButtonClick}},[_c('span',{staticClass:"Text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }